var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7494 12.8035C13.8124 12.864 13.8964 12.8978 13.9838 12.8978H14.3063C14.6087 12.8978 14.8988 13.0179 15.1127 13.2317L19.7754 17.8925C20.2586 18.3732 20.2586 19.1588 19.7754 19.6395C19.2922 20.1202 18.5026 20.1202 18.0195 19.6395L13.3435 14.9874C13.1306 14.7756 13.0109 14.4877 13.0109 14.1874V13.8681C13.0109 13.7797 12.9765 13.6948 12.915 13.6313C12.79 13.5023 12.5869 13.4933 12.4456 13.6041C10.8216 14.8776 8.67456 15.5163 6.39963 15.1372C3.12345 14.5862 0.50722 11.866 0.106536 8.58315C-0.506274 3.62364 3.68912 -0.550324 8.6741 0.0593566C11.9739 0.457994 14.7079 3.06086 15.2618 6.3203C15.6427 8.58286 15.0013 10.7183 13.7221 12.3337C13.6104 12.4749 13.6194 12.6789 13.7494 12.8035ZM2.40448 7.62202C2.40448 10.5414 4.77323 12.8981 7.70765 12.8981C10.6421 12.8981 13.0108 10.5414 13.0108 7.62202C13.0108 4.70259 10.6421 2.34594 7.70765 2.34594C4.77323 2.34594 2.40448 4.70259 2.40448 7.62202Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.f5585ead.svg";
export { ForwardRef as ReactComponent };